import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import ModuleIconBadge from "../ModuleIconBadge";

/**
 * Header for the top-level app pages (Projects, AIMS, Software, Client data,
 * Licences) - the ones not tied to a plant, so no plant card as on
 * PageHeader. The module badge, a title, a one-line subtitle and optional
 * actions on the right.
 */
export default function AppPageHeader({ moduleKey, title, subtitle, actions }) {
  return (
    <Stack
      direction={{ xs: "column", sm: "row" }}
      spacing={2}
      alignItems={{ sm: "center" }}
      justifyContent="space-between"
      sx={{ mb: 3 }}
    >
      <Stack direction="row" spacing={1.5} alignItems="center">
        {moduleKey && <ModuleIconBadge moduleKey={moduleKey} size="lg" />}
        <Box>
          <Typography variant="h1">{title}</Typography>
          {subtitle && (
            <Typography variant="body2" color="text.secondary">
              {subtitle}
            </Typography>
          )}
        </Box>
      </Stack>
      {actions && (
        <Stack direction="row" spacing={1} alignItems="center">
          {actions}
        </Stack>
      )}
    </Stack>
  );
}
